import { render, staticRenderFns } from "./shipmentDialog.vue?vue&type=template&id=412ab665&scoped=true"
import script from "./shipmentDialog.vue?vue&type=script&lang=js"
export * from "./shipmentDialog.vue?vue&type=script&lang=js"
import style0 from "./shipmentDialog.vue?vue&type=style&index=0&id=412ab665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ab665",
  null
  
)

export default component.exports